import { render, staticRenderFns } from "./CGU.vue?vue&type=template&id=4007d9c9&scoped=true&"
import script from "./CGU.vue?vue&type=script&lang=js&"
export * from "./CGU.vue?vue&type=script&lang=js&"
import style0 from "./CGU.vue?vue&type=style&index=0&id=4007d9c9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4007d9c9",
  null
  
)

export default component.exports